import { Component, OnInit, Inject, Optional } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import {Absence, AbsenceRejectRequest} from 'src/app/_model/Absence';
import { AbsenceService } from 'src/app/_services/absence.service';
import { ToastrService } from 'ngx-toastr';
import { User } from 'src/app/_model/user';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import {LookupService} from '../../_services/lookup.service';
@Component({
  selector: 'app-absencereject',
  templateUrl: './absencereject.component.html',
  styleUrls: ['./absencereject.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule
  ]
})
export class AbsencerejectComponent implements OnInit {

  request: AbsenceRejectRequest = new AbsenceRejectRequest();
  currentUser: User;
  selectedRejectReason: any = {};
  rejectReasons: any[];
  rejectDescription = '';

  constructor(public dialogRef: MatDialogRef<AbsencerejectComponent>,
              @Optional() @Inject(MAT_DIALOG_DATA) public data: Absence,
              private authService: AuthenticationService,
              private absenceService: AbsenceService,
              private toastr: ToastrService,
              private lookupService: LookupService) {
      this.currentUser = this.authService.currentUserValue;
  }

  ngOnInit() {
    this.rejectReasons = this.lookupService.localRejectReasonLookupList();
  }

  rejectAbsence(absence: Absence) {
    this.request.employeeId = this.currentUser.employeeId;
    this.request.operationRecordId = absence.id;
    this.request.operationTableName = 'ABSENCE';
    this.request.rejectDescription = this.rejectDescription;
    this.request.rejectReasonId = this.selectedRejectReason.id;

    this.absenceService.rejectAbsence(this.request).subscribe(result => {
      this.toastr.success('reddetme işlemi başarılı', '');
      this.dialogRef.close(true);
    }, error => {
      this.toastr.error(error.error.msg, 'Hata');
      this.dialogRef.close(false);
    });
  }
}
